import React, { useEffect } from "react";

import Seta from "../../../../Assets/images/seta.png";

import {
	Document,
	Font,
	Image,
	Page,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";

import Roboto from "../../../../Assets/fonts/Roboto-Bold.ttf";

import { useState } from "react";
import { VendaService } from "../../../../service/venda_service";

Font.register({
	family: "Roboto bold",
	format: "truetype",
	src: Roboto,
});

const styles = StyleSheet.create({
	page: {
	},
	body: {
		paddingLeft: "7px",
		paddingRight: "7px",
		width: "100%",
		height: "auto",
		backgroundColor: "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flex: 1,
		paddingBottom: "2px",
	},
	containerText: {
		marginBottom: "1px",
		maxWidth: "180px"
	},
	containerTitleText: {
		marginBottom: "3px",
		justifyContent: "center",
	},
	containerTitleCultureText: {
		textTransform: "uppercase",
		marginLeft: "40px",
		marginRight: "40px",
	},
	containerQrcode: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	qrCode: {
		width: "75px",
	},
	qrCodeContainer: {
		paddingTop: 3,
		width: "100%",
		height: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "flex-start",
		color: "black",
	},
	qrCodeContainerTextSubTitle: {
		fontSize: "30px",
	},
	footer: {
		position: "absolute",
		bottom: 2,
		width: "100%",
		height: "13px",
	},
	containerFooter: {
		width: "100vw",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
	},
	paggingContainer: {
		width: "100%",
		backgroundColor: "black",
		height: "10px",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		paddingHorizontal: "2px",
	},
	paggingText: {
		fontSize: "6px",
		fontFamily: "Roboto bold",
		color: "white",
		textAlign: "center",
		flex: 1,
	},
	imgFooterInvetida: {
		height: "8px",
		width: "8px",
		transform: "scaleX(-1)",
	},
	imgFooter: {
		height: "8px",
		width: "8px",
	},
	// textTransform
	TextBoldTitle: {
		fontFamily: "Roboto bold",
		fontSize: "11px",
		textTransform: "uppercase",
	},
	BodyTextBoldTitle: {
		marginTop: 5,
		marginBottom: 5,
		alignItems: "center",
		justifyContent: "center",
	},
	TextBoldSubTitle: {
		fontFamily: "Roboto bold",
		fontSize: "7px",
	},
	TextBoldNumber: {
		fontFamily: "Roboto bold",
		fontSize: "10px",
	},
	TextBold: {
		fontFamily: "Roboto bold",
		fontSize: "6px",
	},
	TextNormal: {
		fontSize: "6px",
		lineHeight: 1.1,
	},
	TextNormalCompact: {
		fontSize: "6px",
		lineHeight: 1.1,
		marginTop: 0,
		marginBottom: 0,
		paddingTop: 0,
		paddingBottom: 0,
	},
	TextNormalQrCode: {
		fontFamily: "Roboto bold",
		fontSize: "4px",
	},
});

const PdfHangTags = (props) => {
	const vendaItemId = props.item;
	const vendaId = props.venda;
	const [venda, setVenda] = useState(null);
	const [vendaItem, setVendaItem] = useState(null);
	const [loading, setLoading] = useState(true);
	const ids = props.ids;

	const vendaService = new VendaService();

	useEffect(() => {
		initData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const formatCpfCnPJ = (value) => {
		if (!value) return "";
		if (value.length > 11) {
			value =
				value.substring(0,2) +
				"." +
				value.substring(2, 5) +
				"." +
				value.substring(5, 8) +
				"/" +
				value.substring(8, 12) +
				"." +
				value.substring(12);
		} else {
			value =
				value.substring(0,3) +
				"." +
				value.substring(3,6) +
				"." +
				value.substring(6,9) +
				"-" +
				value.substring(9);
		}
		return value;
	};

	const getNomeProduto = (vendaItem) => {
		if (!vendaItem) return "Produto não informado";
		const cultura = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.cultura || "";
		const variedade = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.variedade || "";
		return cultura && variedade
			? `${cultura} ${variedade}`
			: cultura || variedade || "Produto não informado";
	};

	const initData = async () => {
		try {
			if (!vendaId || !vendaItemId) {
				setLoading(false);
				return;
			}

			const vendaData = await vendaService.getById(vendaId);
			if (!vendaData) {
				setLoading(false);
				return;
			}

			setVenda(vendaData);

			const item = vendaData.itens?.find((i) => i.ordemProducaoId === vendaItemId);
			setVendaItem(item);

			setLoading(false);
		} catch (error) {
			console.error("Erro ao carregar dados da venda:", error);
			setLoading(false);
		}
	};


	function checkValid() {
		return props.checkDist === "0" ? true : false;
	}

	function checkDoubleTag() {
		return props.doubleTag === "0" ? true : false;
	}

	function QRCodePage({ id }) {
		const dataUrl = document.getElementById(id).toDataURL();

		// Preparar documentos formatados
		const unidadeCnpj = venda?.unidadeDistribuidora?.cpf_cnpj || "";
		const unidadeDoc = unidadeCnpj.length > 11
			? `CNPJ: ${formatCpfCnPJ(unidadeCnpj)}`
			: unidadeCnpj.length > 0 ? `CPF: ${formatCpfCnPJ(unidadeCnpj)}` : "";

		const clienteCpfCnpj = venda?.cliente?.cpfCnpj || "";
		const clienteDoc = clienteCpfCnpj.length > 11
			? `CNPJ: ${formatCpfCnPJ(clienteCpfCnpj)}`
			: clienteCpfCnpj.length > 0 ? `CPF: ${formatCpfCnPJ(clienteCpfCnpj)}` : "";

		const TagContent = () => (
			<View style={{
				width: "100%",
				height: 198.43,
				display: "flex",
				flexDirection: "column",
				position: "relative"
			}}>
				<View style={styles.BodyTextBoldTitle}>
					<Text style={styles.TextBoldTitle}>
						{getNomeProduto(vendaItem)}
					</Text>
				</View>
				<View style={[styles.body, {paddingBottom: "15px", height: "173px", overflow: "hidden"}]}>
					<View style={styles.qrCodeContainer}>
						<View style={{width: "60%"}}>
							<View style={{marginBottom: "3px", justifyContent: "flex-start", width: "100%"}}>
								<View style={{flexDirection: "row", flexWrap: "nowrap", marginBottom: "2px", width: "100%"}}>
									<Text style={styles.TextBoldSubTitle}>Peso Líquido Mínimo: </Text>
									<Text style={styles.TextBoldNumber}>{`${vendaItem?.ordemProducao?.embalagemProdutoFinal?.quantidade} ${vendaItem?.ordemProducao?.embalagemProdutoFinal?.unidadeMedida?.sigla}`}</Text>
								</View>
								<Text style={[styles.TextBold, {fontSize: 5.5}]}>Código de Rastreio: {`${venda?.numeroVenda}-${vendaItem?.ordemProducao?.loteRastreabilidade}`}</Text>
							</View>
							<View style={styles.containerText}>
								<Text style={styles.TextNormal}>Distribuído por: {venda?.unidadeDistribuidora?.nome || "Não informado"}</Text>
								{unidadeDoc && <Text style={styles.TextNormal}>{unidadeDoc}</Text>}
								<Text style={styles.TextNormal}>
									{venda?.unidadeDistribuidora?.endereco ?
											[(venda.unidadeDistribuidora.endereco.logradouro || venda.unidadeDistribuidora.endereco.endereco), venda.unidadeDistribuidora.endereco.bairro, [venda.unidadeDistribuidora.endereco.cidade, venda.unidadeDistribuidora.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ")
											: ""}
								</Text>
							</View>
							{checkValid() && (
								<View style={styles.containerText}>
									<Text style={styles.TextNormalCompact}>Distribuídor por: {venda?.cliente?.nome || venda?.cliente?.nomeFantasia}</Text>
									{clienteDoc && <Text style={styles.TextNormalCompact}>{clienteDoc}</Text>}
									<Text style={styles.TextNormalCompact}>
										{venda?.cliente?.endereco ? [(venda.cliente.endereco.logradouro || venda.cliente.endereco.endereco), venda.cliente.endereco.bairro, [venda.cliente.endereco.cidade, venda.cliente.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ") : ""}
									</Text>
								</View>
							)}
							<View style={styles.containerText}>
								<Text style={styles.TextNormal}>
									{`${vendaItem?.ordemProducao?.dataProducao ? `Data de Embalagem: ${new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")}\n` : ""}Data de Entrega: ${new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}${(vendaItem?.ordemProducao?.dataValidade && props.showExpiryDate) ? `\nData de Validade: ${new Date(vendaItem?.ordemProducao?.dataValidade).toLocaleDateString("pt-BR")}` : ""}`}
								</Text>
							</View>
						</View>
						{/* lado direito da etiqueta */}
						<View style={styles.containerQrcode}>
							<Text style={[styles.TextNormalQrCode, {textAlign: "center", marginBottom: 2}]}>CONHEÇA ORIGEM DESTE PRODUTO</Text>
							<Image src={dataUrl} style={styles.qrCode} />
						</View>
					</View>
				</View>
				{/* roda pé  */}
				<View style={styles.footer}>
					<View style={styles.paggingContainer}>
						<Image src={Seta} style={styles.imgFooter} />
						<Text style={styles.paggingText}>ORIGEM RASTREADA</Text>
						<Image src={Seta} style={styles.imgFooterInvetida} />
						<Text style={styles.paggingText}>sisagri.com.br</Text>
						<Image src={Seta} style={styles.imgFooterInvetida} />
					</View>
				</View>
			</View>
		);

		return (
			<Page
				key={`page_${id}`}
				size={{ width: 283.46, height: checkDoubleTag() ? 416.66 : 198.43 }}
				style={styles.page}
			>
				<TagContent />
				{checkDoubleTag() && (
					<>
						{/* Espaçamento de 0.7cm entre as etiquetas */}
						<View style={{height: 19.8, backgroundColor: "transparent"}} />
						<TagContent />
					</>
				)}
			</Page>
		);
	}

	return (
		!loading ?
			<Document>
				{ids.map((id) => (
					<QRCodePage id={id} key={id} />
				))}
			</Document>
			:<Document></Document>
	);
};


export default PdfHangTags;
